import { TCollection } from '@/interfaces/collections';
import React from 'react';

interface MediaCountProps {
  collectionData: TCollection;
}

export default function MediaCount({ collectionData }: MediaCountProps) {
  const mediaCountFn = () => {
    const media = {
      photos: 0,
      videos: 0,
      links: 0,
    };
    if (collectionData) {
      collectionData.bookmarks.forEach((bookmark) => {
        if (bookmark.type === 'photo') media.photos++;
        if (bookmark.type === 'link') media.links++;
        if (bookmark.type === 'video' || bookmark.type === 'clip') media.videos++;
      });
    }
    return media;
  };
  return (
    <div className="w-full mb-[16px] flex flex-col text-center">
      <p className="font-normal font-adieu text-sm leading-none tracking-[2.1px] uppercase 3xl:text-sm 4xl:text-[15px]">
        {mediaCountFn().photos} photos{' '}
        {mediaCountFn().videos > 0 && <>| {mediaCountFn().videos} videos</>}{' '}
        {mediaCountFn().links > 0 && <>| {mediaCountFn().links} links</>}
      </p>
    </div>
  );
}
